import React, {FC}                              from "react";
import bnc                                      from "bnc";
import {HBox, LGap}                             from "@sirius/ui-lib/src/blocks/Layout";
import {Icon}                                   from "@sirius/ui-lib/src/blocks/Controls";
import {ElementClientValidationLabelType}       from "./@types";
import {iconLevels}                             from "./IconLevels";
import                                               "./ElementClientValidationLabel.less"

export const block = new bnc('element-client-validation-label');

export const ElementClientValidationLabel : FC<ElementClientValidationLabelType> = ({report:{level, message}}) =>
    <HBox className={block + block.mod('level', level)}>
        <Icon icon={iconLevels[level]}/>
        <LGap/>
        <span>{message}</span>
    </HBox>
;
